import React from 'react';
import { PutAway } from '../shared';
import useMSQueue from './queue';
import './microsurvey-popup.scss';
export default function MicroSurvey() {
    const [QueuedItem, nextItem] = useMSQueue();
    if (!QueuedItem) {
        return null;
    }
    return (React.createElement("div", { id: 'microsurvey' },
        React.createElement(QueuedItem, { onDone: nextItem },
            React.createElement(PutAway, { onClick: nextItem }))));
}
const SF_DURATION = 200; // sticky-footer animation duration
